<template>
  <v-container>
    <v-row class="mt-16">
      <v-col cols="12">
        <v-row class="flex justify-center align-center mt-16">
          <v-card
            width="450"
            flat
            outlined
          >
            <v-card-title class="blue white--text font-weight-thin">Konfirmasi</v-card-title>
            <v-card-text class="mt-5">
              <div class="text-center">
                {{ registerResult.message }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                dense
                :color="theme.color"
                @click="$router.push({name:'login'})"
              >Halaman Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
      
<script>
import { mapState, mapActions } from "vuex";
import { domainURL } from "../../../../../.env";

export default {
  name: "register-user-callback",
  components: {},
  data: () => ({
    registerResult: {
      color: "green",
      message: "Mohon Menunggu Sedang Melakukan Singkronisasi Akun",
    },
  }),
  mounted() {
    this.postGoogleCallback();
  },
  computed: {
    ...mapState([
      "device",
      "theme",
      "info",
      "snackbar",
      "loading",
      "page",
      "http",
    ]),
  },
  methods: {
    ...mapActions(["setPage", "getAppInfo", "snackbarClose", "catchError"]),
    postGoogleCallback: async function () {
      try {
        const url = new URL(
          domainURL.BASE + "api/v2/auth/register-umkm-callback"
        );

        url.search = await window.location.search;

        let {
          data: { success, code, message },
        } = await this.http.get(url.toString());
        if (!success) {
          this.registerResult.color = "red";
          this.registerResult.message = message;
        }

        this.registerResult.color = "green";
        this.registerResult.message = message;
      } catch (error) {
        this.catchError(error);
      }
    },
  },
};
</script>
      
<style>
</style>